import React, { useState, useEffect } from "react";
import plusIcon from "../assets/img/icon-plus.png";
import Popup from "./Popup";
import { formatDateToDDMMYY } from "../utils/format-time";
import { formatNumberWithCommas } from "../utils/format-number";

const isSameProductId = (left, right) => String(left) === String(right);

const WholesaleOrderTable = ({
  data,
  currentPromotions,
  setActiveTab,
  promotionByTotal,
  setPromotionByTotal,
  currencyType,
  THBToMMK,
  MMKToTHB,
  setSubTotal,
  setSaleProducts,
  setSubTotalTHB,
  setSubTotalMMK,
}) => {
  const [popup, setPopup] = useState({
    id: "",
    show: false,
  });

  const [errorBuyMessage, setErrorBuyMessage] = useState("");

  const onCloseClick = (e) => {
    e.preventDefault();
    setPopup({
      id: "",
      show: false,
    });
  };

  const convertCurrency = (product, currencyType, THBToMMK, MMKToTHB) => {
    let convertedPrice;

    if (currencyType === product.currency) {
      convertedPrice = product.wholesale_price;
    } else {
      if (product.currency === "MMK") {
        convertedPrice = product.wholesale_price * THBToMMK;
      } else {
        convertedPrice = nearValue(product.wholesale_price / THBToMMK);
      }
    }
    return convertedPrice;
  };

  useEffect(() => {
    document
      .getElementById("external-popup")
      .classList.toggle("show", popup.show);
    const openedEl = document.querySelector(".popup");

    const handleDocumentClick = (e) => {
      if (e.target != openedEl && !openedEl.contains(e.target)) {
        openedEl.parentNode.classList.remove("show");
        onCloseClick(e);
      }
    };
    if (openedEl) {
      setTimeout(() => {
        document.addEventListener("click", handleDocumentClick);
      }, 100);
    }
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [popup.show]);

  const onDetailClick = (e) => {
    e.preventDefault();
    const id = e.target.parentNode.parentNode.id;
    // console.log(id)
    setPopup({
      show: true,
      eID: "promotion-popup",
      id: id,
    });
  };

  const getSubTotal = (currencyType, seperatedType) => {
    let total = 0;

    if (currencyType === "BAHT") {
      data.forEach((p) => {
        total += parseFloat(p.convertedTHBTotal || 0);
      });
    } else if (currencyType === "MMK") {
      data.forEach((p) => {
        total += parseFloat(p.convertedMMKTotal || 0);
      });
    } else if (currencyType === "SEPERATED" && seperatedType === "MMK") {
      data.forEach((p) => {
        if (p.currency === "MMK") {
          const q = Number(p.quantity) || 0;
          const price =
            Number(p.mmkPrice) || convertCurrency(p, "MMK", THBToMMK, MMKToTHB);
          total += q * price;
        }
      });
    } else if (currencyType === "SEPERATED" && seperatedType === "BAHT") {
      data.forEach((p) => {
        if (p.currency === "BAHT") {
          const q = Number(p.quantity) || 0;
          const price =
            Number(p.thbPrice) ||
            convertCurrency(p, "BAHT", THBToMMK, MMKToTHB);
          total += q * price;
        }
      });
    }

    return parseFloat((total || 0).toFixed(2));
  };

  useEffect(() => {
    if (currencyType === "SEPERATED") {
      setSubTotalMMK(getSubTotal(currencyType, "MMK"));
      setSubTotalTHB(getSubTotal(currencyType, "BAHT"));
    } else {
      setSubTotal(getSubTotal(currencyType));
    }
  }, [data, currencyType]);

  const appliedCrossProductRows = (() => {
    const appliedCrossPromotions = data.filter(
      (item) =>
        item.applyPromo &&
        item.promotion_type === "By Cross Product" &&
        item.promotion
    );

    const seenPromotionIds = new Set();

    return appliedCrossPromotions.flatMap((item) => {
      const promotionId =
        item.promotion?.promotion_by_cp_id ??
        item.promotion?.promotion_id ??
        item.promotion?.id ??
        item.product_id;

      if (seenPromotionIds.has(promotionId)) {
        return [];
      }
      seenPromotionIds.add(promotionId);

      const eligibleTimes = Number(item.promotion?.eligibleTimes) || 0;
      const promoProducts = item.promotion?.promoProducts ?? [];

      return promoProducts.map((promoProduct, index) => ({
        isPromoReward: true,
        rowKey: `wholesale-cross-product-${promotionId}-${index}`,
        barcode: promoProduct.product?.barcode ?? promoProduct.barcode ?? "-",
        product_name: promoProduct.product?.product_name ?? "-",
        quantity: eligibleTimes * (Number(promoProduct.quantity) || 0),
        mmkPrice: 0,
        thbPrice: 0,
        convertedMMKTotal: 0,
        convertedTHBTotal: 0,
        promotionLabel: "Cross Product Reward",
      }));
    });
  })();

  const tableRows = [...data, ...appliedCrossProductRows];

  const PromotionPopup = ({ id }) => {
    let product,
      resolvedPromotion,
      eligiblePromo,
      applyPromo,
      minimum_total_amount,
      promotion_amount,
      start_date,
      end_date;
    console.log("promotionByTotal retrieve", promotionByTotal);
    //console.log("ID",id)

    if (id === "By Total") {
      const promo = promotionByTotal.promotion;

      eligiblePromo = promo.promotion_type;
      applyPromo = promotionByTotal.applyPromo;
      minimum_total_amount = promo.minimum_total_amount;
      promotion_amount = promo.promotion_amount;
      start_date = promo.start_date;
      end_date = promo.end_date;
    } else {
      product = data.find((item) => isSameProductId(item.product_id, id));
      resolvedPromotion = product?.promotion ?? product?.crossPromotionDetail;

      if (!resolvedPromotion && product?.promotion_type === "By Cross Product") {
        resolvedPromotion = currentPromotions?.find((promo) => {
          if (promo.promotion_type !== "By Cross Product") {
            return false;
          }

          const crossableProducts = promo.crossableProducts ?? [];
          const hasCurrentProduct = crossableProducts.some(
            (crossableProduct) =>
              isSameProductId(crossableProduct.product_id, product.product_id)
          );

          if (!hasCurrentProduct) {
            return false;
          }

          return crossableProducts.every((crossableProduct) =>
            data.some(
              (saleProduct) =>
                isSameProductId(
                  saleProduct.product_id,
                  crossableProduct.product_id
                )
            )
          );
        });
      }

      if (!resolvedPromotion) {
        resolvedPromotion = product;
      }

      eligiblePromo = product.promotion_type;
      applyPromo = product.applyPromo;
    }

    const crossableProducts = resolvedPromotion?.crossableProducts ?? [];
    const promoProducts = resolvedPromotion?.promoProducts ?? [];
    const promoStartDate = resolvedPromotion?.start_date ?? product?.start_date;
    const promoEndDate = resolvedPromotion?.end_date ?? product?.end_date;

    return (
      <div className="popup">
        <div className="flex flex-row-reverse">
          <button onClick={onCloseClick}>
            <img
              src={plusIcon}
              alt="close icon"
              className="rotate-45 w-5 h-5"
            />
          </button>
        </div>
        {eligiblePromo === "By Total" && (
          <div className="flex justify-center py-2">
            <table className="promotion-detail-table">
              <tbody>
                <tr>
                  <td>Promotion Type</td>
                  <td className="px-8">:</td>
                  <td>Amount</td>
                </tr>
                <tr>
                  <td>Minimum Total Amount</td>
                  <td className="px-8">:</td>
                  <td>{minimum_total_amount}</td>
                </tr>
                <tr>
                  <td>Promotion Amount</td>
                  <td className="px-8">:</td>
                  <td>{promotion_amount}</td>
                </tr>
                <tr>
                  <td>Start Date</td>
                  <td className="px-8">:</td>
                  <td>{formatDateToDDMMYY(new Date(start_date))}</td>
                </tr>
                <tr>
                  <td>End Date</td>
                  <td className="px-8">:</td>
                  <td>{formatDateToDDMMYY(new Date(end_date))}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

        {eligiblePromo === "By BOGO" && (
          <div className="flex justify-center py-2">
            <table className="promotion-detail-table">
              <tbody>
                <tr>
                  <td>Promotion Type</td>
                  <td className="px-8">:</td>
                  <td>Buy One Get One</td>
                </tr>
                <tr>
                  <td>Product Name</td>
                  <td className="px-8">:</td>
                  <td>{product.product_name}</td>
                </tr>
                <tr>
                  <td>Start Date</td>
                  <td className="px-8">:</td>
                  <td>{formatDateToDDMMYY(new Date(product.start_date))}</td>
                </tr>
                <tr>
                  <td>End Date</td>
                  <td className="px-8">:</td>
                  <td>{formatDateToDDMMYY(new Date(product.end_date))}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

        {eligiblePromo === "By Percent" && (
          <div className="flex justify-center py-2">
            <table className="promotion-detail-table">
              <tbody>
                <tr>
                  <td>Promotion Type</td>
                  <td className="px-8">:</td>
                  <td>Percent</td>
                </tr>
                <tr>
                  <td>Product Name</td>
                  <td className="px-8">:</td>
                  <td>{product.product_name}</td>
                </tr>
                <tr>
                  <td>Promotion Percent</td>
                  <td className="px-8">:</td>
                  <td>{product.percent_amount}%</td>
                </tr>
                <tr>
                  <td>Start Date</td>
                  <td className="px-8">:</td>
                  <td>{formatDateToDDMMYY(new Date(product.start_date))}</td>
                </tr>
                <tr>
                  <td>End Date</td>
                  <td className="px-8">:</td>
                  <td>{formatDateToDDMMYY(new Date(product.end_date))}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

        {eligiblePromo === "By Cross Product" && (
          <div className="flex justify-center py-2">
            <table className="promotion-detail-table">
              <tbody>
                <tr>
                  <td>Promotion Type</td>
                  <td className="px-8">:</td>
                  <td>Cross Product</td>
                </tr>
                <tr>
                  <td>Buy Products</td>
                  <td className="px-8">:</td>
                  <td>
                    {crossableProducts.map((item, index) => (
                      <div key={`buy-${index}`}>
                        {`${item.product?.product_name ?? "-"} x ${item.quantity}`}
                      </div>
                    ))}
                  </td>
                </tr>
                <tr>
                  <td>Get Products</td>
                  <td className="px-8">:</td>
                  <td>
                    {promoProducts.map((item, index) => (
                      <div key={`get-${index}`}>
                        {`${item.product?.product_name ?? "-"} x ${item.quantity}`}
                      </div>
                    ))}
                  </td>
                </tr>
                <tr>
                  <td>Start Date</td>
                  <td className="px-8">:</td>
                  <td>{formatDateToDDMMYY(new Date(promoStartDate))}</td>
                </tr>
                <tr>
                  <td>End Date</td>
                  <td className="px-8">:</td>
                  <td>{formatDateToDDMMYY(new Date(promoEndDate))}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

        <div className="flex justify-center">
          {/* <button className={applyPromo ? "grey-btn" : "gold-btn"} onClick={(e) => {
                        if (eligiblePromo.promotion_type === "By Total") {
                            setPromotionByTotal({ promotion: promotionByTotal.promotion, applyPromo: true })
                            setActiveTab(1)
                        } else {

                            setSaleProducts(prevData => {
                                return prevData.map(product => (product.product_id === id ? { ...product, applyPromo: true } : product))
                            });
                            if (eligiblePromo.promotion_type === "By Percent") {
                                setActiveTab(2)
                            } else if (eligiblePromo.promotion_type === "By BOGO") {
                                setActiveTab(3)
                            } else {
                                setActiveTab(4)
                            }
                        }
                        onCloseClick(e)
                    }}>{applyPromo ? "Revoke" : "Apply"}</button> */}
          <button
            className={applyPromo ? "grey-btn" : "gold-btn"}
            onClick={(e) => {
              //e.preventDefault(); // prevent form submission if inside a <form>
              // if (eligiblePromo.promotion_type === "By Total") {
              //     setPromotionByTotal({
              //         promotion: promotionByTotal.promotion,
              //         applyPromo: !applyPromo // toggle
              //     });
              //     setActiveTab(1);
              // }
              if (eligiblePromo === "By Total") {
                setPromotionByTotal({
                  promotion: promotionByTotal.promotion,
                  applyPromo: !applyPromo,
                });
                setActiveTab(1);
              } else {
                setSaleProducts((prevData) =>
                  prevData.map((product) =>
                    product.product_id === id
                      ? { ...product, applyPromo: !applyPromo }
                      : product
                  )
                );

                if (!applyPromo) {
                  // Only change tab if applying
                  if (eligiblePromo === "By Percent") {
                    setActiveTab(2);
                  } else if (eligiblePromo === "By BOGO") {
                    setActiveTab(3);
                  } else {
                    setActiveTab(4);
                  }
                }
              }

              onCloseClick(e);
            }}
          >
            {applyPromo ? "Revoke" : "Apply"}
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="table-container">
      <div className="mb-4 flex justify-between">
        <h3 className="table-title">Wholesale Sales Order Information</h3>
      </div>
      <table className="x-table product-list-table">
        <thead>
          <tr>
            <th>Barcode</th>
            <th>Product Name</th>
            <th>Quantity</th>
            <th>MMK Price</th>
            <th>THB Price</th>
            <th>MMK Total</th>
            <th>THB Total</th>
            <th>Promotion</th>
            <th className="button-col"></th>
          </tr>
        </thead>
        <tbody>
          {tableRows.map((item) => {
            // console.log("MMK Total",item.convertedMMKTotal);
            const convertedPriceMMK = item.isPromoReward
              ? 0
              : convertCurrency(item, "MMK", THBToMMK, MMKToTHB);
            const convertedPriceBAHT = item.isPromoReward
              ? 0
              : convertCurrency(item, "BAHT", THBToMMK, MMKToTHB);
            return (
              <tr
                key={item.rowKey ?? item.product_id}
                id={item.isPromoReward ? item.rowKey : item.product_id}
              >
                <td>{item.barcode}</td>
                <td>{item.product_name}</td>
                <td>
                  <input
                    id={`qty-${item.product_id}`}
                    className="w-16 border border-solid border-neutral-300 rounded"
                    min="1"
                    defaultValue={1}
                    value={item.quantity}
                    type="text"
                    disabled={item.isPromoReward}
                    readOnly={item.isPromoReward}
                    //pattern="[0-9]{1,}"
                    pattern="^[0-9]+$"
                    inputMode="numeric"
                    onInput={(e) => {
                      if (item.isPromoReward) return;
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                    onChange={(e) => {
                      if (item.isPromoReward) return;
                      const quantity = e.target.value;

                      if (quantity < 1) {
                        setErrorBuyMessage(
                          "Quantity must be greater than or equal 1."
                        );
                      } else if (isNaN(quantity) || quantity < 1) {
                        setErrorBuyMessage(
                          "Quantity must be digit and number."
                        );
                      } else {
                        setErrorBuyMessage("");
                      }
                      const mmkTotal = (quantity * item.mmkPrice).toFixed(2);
                      const thbTotal = (quantity * item.thbPrice).toFixed(2);

                      const convertedMMKTotal =
                        item.currency === "MMK"
                          ? mmkTotal
                          : (quantity * convertedPriceMMK).toFixed(2);

                      const convertedTHBTotal =
                        item.currency === "BAHT"
                          ? thbTotal
                          : (quantity * convertedPriceBAHT).toFixed(2);

                      setSaleProducts((prevData) => {
                        return prevData.map((product) =>
                          product.product_id === item.product_id
                            ? {
                                ...product,
                                quantity,
                                mmkTotal,
                                thbTotal,
                                convertedMMKTotal,
                                convertedTHBTotal,
                              }
                            : product
                        );
                      });

                      setSubTotal(getSubTotal(currencyType));
                    }}
                  />
                  {errorBuyMessage && (
                    <div className="text-red-500 text-sm mt-1">
                      {errorBuyMessage}
                    </div>
                  )}
                </td>
                <td>
                  <input
                    type="text"
                    readOnly={true}
                    disabled={true}
                    id={`MMK-price-${item.product_id}`}
                    className="w-16"
                    // const thbPrice = item.mmkPrice ? item.mmkPrice : convertCurrency(item, "MMK", exchangeRate, reverseExchangeRate)
                    //value={item.mmkPrice ? item.mmkPrice : convertCurrency(item, "MMK", THBToMMK , MMKToTHB )}
                    value={formatNumberWithCommas(
                      item.mmkPrice !== null && item.mmkPrice !== undefined
                        ? item.mmkPrice
                        : convertedPriceMMK
                    )}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    readOnly={true}
                    disabled={true}
                    id={`THB-price-${item.product_id}`}
                    className="w-16"
                    value={formatNumberWithCommas(
                      item.thbPrice !== null && item.thbPrice !== undefined
                        ? item.thbPrice
                        : convertedPriceBAHT
                    )}
                    //value={item.thbPrice ? item.thbPrice : convertCurrency(item, "BAHT",THBToMMK, MMKToTHB )}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    readOnly={true}
                    disabled={true}
                    id={`MMK-total-${item.product_id}`}
                    className="w-16"
                    //value={ (item.mmkTotal !== null && item.mmkTotal !== undefined) ? item.mmkTotal : item.convertedMMKTotal }
                    // value={item.mmkTotal ? item.mmkTotal : item.convertedMMKTotal}
                    value={formatNumberWithCommas(item.convertedMMKTotal)}
                  />
                </td>

                <td>
                  <input
                    type="text"
                    readOnly={true}
                    disabled={true}
                    id={`THB-total-${item.product_id}`}
                    className="w-16"
                    value={formatNumberWithCommas(item.convertedTHBTotal)}
                    //value={ (item.thbTotal !== null && item.thbTotal !== undefined) ? item.thbTotal : item.convertedTHBTotal }
                    //value={item.thbTotal ? item.thbTotal : item.convertedTHBTotal}
                  />
                </td>
                <td className={item.applyPromo ? "apply" : ""}>
                  {!item.isPromoReward && item.promotion_type && (
                    <a
                      href=""
                      className={"promotion-btn"}
                      onClick={onDetailClick}
                      id={`promo-${item.product_id}`}
                    >
                      {item.promotion_type}
                    </a>
                  )}
                  {item.isPromoReward && (
                    <span className="promotion-btn">{item.promotionLabel}</span>
                  )}
                </td>
                <td
                  className="button-col"
                  onClick={(e) => {
                    if (item.isPromoReward) return;
                    const filterItem = data.filter(
                      (item) =>
                        item.product_id !== e.target.parentNode.parentNode.id
                    );
                    setSaleProducts(filterItem);
                  }}
                >
                  {!item.isPromoReward && (
                    <img
                      src={plusIcon}
                      alt="close icon"
                      className="rotate-45 w-5 h-5"
                    />
                  )}
                </td>
              </tr>
            );
          })}
          <tr id="By Total">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td className="font-bold">Sub Total</td>

            {currencyType === "MMK" && (
              <td>{formatNumberWithCommas(getSubTotal(currencyType, "MMK"))}</td>
            )}
            {currencyType === "BAHT" && (
              <td>{formatNumberWithCommas(getSubTotal(currencyType, "BAHT"))}</td>
            )}
            {currencyType === "SEPERATED" && (
              <React.Fragment>
                <td>{formatNumberWithCommas(getSubTotal(currencyType, "MMK"))}</td>
                <td>{formatNumberWithCommas(getSubTotal(currencyType, "BAHT"))}</td>
              </React.Fragment>
            )}

            <td className={promotionByTotal.applyPromo ? "apply" : ""}>
              {promotionByTotal.promotion && (
                <a
                  href=""
                  className="promotion-btn"
                  id="amount-promo"
                  onClick={onDetailClick}
                >
                  By Total
                </a>
              )}
            </td>
            <td className="button-col"></td>
          </tr>
        </tbody>
      </table>
      <Popup className="popup-container">
        {popup.eID === "promotion-popup" && (
          <PromotionPopup id={popup.id} promoType={popup.promoType} />
        )}
      </Popup>
    </div>
  );
};

function nearValue(input) {
  const output = Math.ceil(input / 100) * 100;
  return output;
}

export default WholesaleOrderTable;
